import React, { useState } from 'react';
import './GundamCard.scss';

const GundamCard = ({ product }) => {
  const [currentImage, setCurrentImage] = useState(product?.images[0]);

  return (
    <div
      className="gundam-slider-card"
      onMouseEnter={() => setCurrentImage(product?.altImages[0])}
      onMouseLeave={() => setCurrentImage(product?.images[0])}
    >
      <div
        className={`gundam-slider-card__image__wrapper ${
          product?.modelNumber === 'ZAKU-CASE3A' ? 'gundam-slider-card__image__wrapper__zaku' : ''
        }`}
      >
        <img alt="gundam" className="gundam-slider-card__image" src={currentImage} />
      </div>
      <div className="gundam-slider-card__details">
        <h5 className="gundam-slider-card__title">{product?.name}</h5>
        <p className="gundam-slider-card__subtitle">Lens Included</p>
        <div className="gundam-slider-card__price-wrapper">
          <p className="gundam-slider-card__price">{product?.price}</p>
          <a
            className="gundam-slider-card__btn odButton odButton--primary"
            href={`/sg/en/${product?.url}`}
            target="_self"
          >
            VIEW
          </a>
        </div>
      </div>
    </div>
  );
};

export default GundamCard;
